<template lang="html">
  <div class="specifications">
    <div class="row nopadding">
      <div class="col-md-6 nopadding bg-100  bg-img-responsive" :style="'background-image:url(https://media.autodisk.nl/fotos/geel/'+type.nModelID+'/16-9/900/b.jpg);'">
        <img :src="'https://media.autodisk.nl/fotos/geel/'+type.nModelID+'/16-9/900/b.jpg'" :alt="type.cMerknaam +' '+ type.cModelnaam"  class="opacity-zero">
      </div>
      <div class="col-md-6 nopadding top-left-before">
        <div class="container info-text text-center row-list">
          <!-- <h2>WhatTheRange</h2> -->
          <img src="../assets/wtr_logo_dark.png" alt="WhatTheRange" class=" text-center">
          <!-- <p>{{text}}</p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['type'],
  data(){
    return {
      text:null
    }
  },
  created(){
    this.getCarModelText()
  },
  methods:{
    getCarModelText(){
      var self = this;
      self.$axios.get('/api-car/getModelTekst/cClient=30abad7b-0b3f-452d-ab65-20c7db9520e8;nModelID='+self.type.nModelID).then((response)=>{
        self.text = response.data['getModelTekstResult'][0].cTekst;
      });
    }
  }
}
</script>

<style lang="scss" scoped="">
.specifications{
  p{
    margin:0 50px 15px;
  }
}
</style>
